/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Shipping_Fee_PayerInputs */

const vi_carrier_form_shipping_fee_payer = /** @type {(inputs: Carrier_Form_Shipping_Fee_PayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bên trả cước`)
};

/**

* @param {Carrier_Form_Shipping_Fee_PayerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_shipping_fee_payer = /** @type {((inputs?: Carrier_Form_Shipping_Fee_PayerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Shipping_Fee_PayerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_shipping_fee_payer(inputs)
});